import { TraceErrorObject } from 'owa-trace';
import { DatapointStatus } from '../types/DatapointEnums';

const errorMapping = {
    RequestNotComplete: DatapointStatus.UserError,
    ServerFailure: DatapointStatus.ServerError,
};

export default function getDatapointStatus(error?: TraceErrorObject): DatapointStatus {
    let datapointStatus = DatapointStatus.ClientError;
    if (error) {
        if (error.responseMessage) {
            datapointStatus = DatapointStatus.ServerError;
        } else if (error.response) {
            datapointStatus =
                error.response.status && Math.floor(error.response.status / 100) == 4
                    ? DatapointStatus.UserError
                    : DatapointStatus.ServerError;
        } else if (error.fetchErrorType) {
            datapointStatus = errorMapping[error.fetchErrorType];
        }
    }

    return datapointStatus;
}
